'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchInput = function (_Component) {
  (0, _inherits3.default)(SearchInput, _Component);

  function SearchInput(props) {
    (0, _classCallCheck3.default)(this, SearchInput);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchInput.__proto__ || (0, _getPrototypeOf2.default)(SearchInput)).call(this, props));

    _this.onChange = function (event) {
      _this.setState({ query: event.target.value });
    };

    _this.onSubmit = function (event) {
      event.preventDefault();
      _this.props.onSubmit(_this.state.query);
    };

    _this.state = {
      query: props.defaultValue
    };
    return _this;
  }

  (0, _createClass3.default)(SearchInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          defaultValue = _props.defaultValue,
          message = _props.message,
          inputLabel = _props.inputLabel,
          buttonText = _props.buttonText,
          loading = _props.loading,
          style = _props.style;


      return _react2.default.createElement(
        'form',
        { onSubmit: this.onSubmit, className: 'quiver-search-input', style: style },
        _react2.default.createElement(_Input2.default, {
          label: inputLabel || 'Search',
          type: 'text',
          defaultValue: defaultValue,
          message: message,
          input: { onChange: this.onChange },
          style: style && style.Input
        }),
        _react2.default.createElement(
          _Button2.default,
          { loading: loading, style: style && style.Button },
          buttonText || 'Search'
        )
      );
    }
  }]);
  return SearchInput;
}(_react.Component);

SearchInput.propTypes = {
  defaultValue: _propTypes2.default.string,
  buttonText: _propTypes2.default.string,
  inputLabel: _propTypes2.default.string,
  message: _propTypes2.default.string,
  onSubmit: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  style: _propTypes2.default.object
};
exports.default = SearchInput;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SearchInput/SearchInput.js
// module id = 644
// module chunks = 11